import React from "react";

export default function Banner(props) {
  return (
    <>
      <section className="blog-page-banner">
        <div className="blog-banner-inner">
          <img className="blog-banner-image" src={props.img} alt="" />
          <div className="blog-banner-overlay" />
          <div className="blog-banner-content">
            <div className="container">
              <h1 className="blog-banner-title">{props.title}</h1>
            </div>
          </div>
        </div>
      </section>
      <style jsx>{`
        .blog-page-banner {
          margin-top: 120px;
        }

        .blog-banner-inner {
          position: relative;
          width: 100%;
          height: 420px;
          overflow: hidden;
        }

        .blog-banner-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center 30%;
          display: block;
        }

        .blog-banner-overlay {
          position: absolute;
          inset: 0;
          background: rgba(21, 21, 21, 0.5);
        }

        .blog-banner-content {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          padding: 0 24px;
        }

        .blog-banner-title {
          color: #ffffff;
          font-size: 40px;
          font-weight: 700;
          text-align: center;
          line-height: 1.3;
          margin: 0;
        }

        @media (max-width: 991px) {
          .blog-page-banner {
            margin-top: 110px;
          }

          .blog-banner-inner {
            height: 360px;
          }

          .blog-banner-title {
            font-size: 30px;
          }
        }

        @media (max-width: 575px) {
          .blog-page-banner {
            margin-top: 100px;
          }

          .blog-banner-inner {
            height: 300px;
          }

          .blog-banner-title {
            font-size: 22px;
          }

          .blog-banner-image {
            object-position: center 20%;
          }
        }
      `}</style>
    </>
  );
}
